module.exports = __webpack_public_path__ + "static/media/LOGO-ALCALDIA-CARRIZAL.4823e43a.svg";